<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-06 18:18:03
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-07-07 10:03:41
 * @name: 注册
 * @Description: 注册
 * @FilePath: \backstage\src\views\Register.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
    <div class="register">
        <step :step="step"></step>
        <!-- 填写手机号 -->
        <set-telephone class="content" :step.sync="step" :register="register" v-if="step === 1"></set-telephone>
        <!-- 完善信息 -->
        <set-info class="content" :step.sync="step" :register="register" v-if="step === 2"></set-info>
        <!-- 注册成功 -->
        <set-result class="content" :step.sync="step" :register="register" v-if="step === 3"></set-result>
    </div>
</template>
<script>
import step from '@/components/register/step';
import setTelephone from '@/components/register/set-telephone';
import setInfo from '@/components/register/set-info';
import setResult from '@/components/register/set-result';
import register from '@/object/login/register.class.js';

export default {
    name: 'register',
    components: {
        step,
        setTelephone,
        setInfo,
        setResult,
    },
    data() {
        return {
            register: new register(),
            step: 1,
        }
    },
}
</script>
<style lang="scss" scoped>
    .register{
        width: 100%;
        height: 100vh;
        @extend .extend-flex-column-normal;
        .content{
            flex: 1;
            width: 100%;
            overflow-y: auto;
        }
    }
</style>